import * as React from 'react'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import {
  message,
  Button,
  Select,
  Icon,
  Modal as AntdModal,
  Row,
  Col,
  Switch,
  Input,
  Dropdown,
} from 'antd'
import moment from 'moment'
import { throttle, debounce, get as _get } from 'lodash'
import posed, { PoseGroup } from 'react-pose'
import RouteWrapper from 'components/HOC/RouteWrapper'
import { ComponentExt } from 'util/reactExt'
import { routeMap } from 'constants/routes'
import CheckGroupTab from 'components/CheckGroup'
import {
  LEVEL_CONFIG_INFO,
  templateType,
  checkType,
  taskType,
} from 'constants/index'
import ConfigCard from 'containers/views/Levelup/ConfigCard'
import ConfigContentModal from 'containers/views/Levelup/ConfigContentModal'
import CheckSettingsModal from 'containers/views/Levelup/CheckSettingsModal'
import FavoritesModal from 'containers/views/Levelup/FavoritesModal'
import CheckGroupModal from 'containers/views/Levelup/CheckGroupModal'
import Validator from 'util/validator'
import { withPopover } from 'components/HOC/AntdWrapper'
import CheckGroupBoard from 'containers/views/Levelup/CheckGroupBoard'
import CheckPanel from 'containers/views/Levelup/CheckPanel'
import Modal from 'react-responsive-modal'
import { levelStrategies } from 'store/LevelStore'
import styles from './index.scss'

let saveConfirm
let favoritesForm
const PER_PAGE = 100
const SAVE_DRAFT_INTERVAL = 1000 * 60 * 5
const Fragment = React.Fragment
const Option = Select.Option
const confirm = AntdModal.confirm
const Search = Input.Search
const TextArea = Input.TextArea
const PosedItem = posed.li({
  flip: {
    transition: {
      scale: {
        type: 'tween',
        duration: 3000,
        velocity: 1,
      },
      default: {
        type: 'tween',
      },
    },
  },
})

interface ILevelConfigProps {
  globalStore: any
  levelStore: any
}

interface ILevelConfigState {
  lesson_id: number
  role_id: number | string
  defaultLessonId: number
  lessonOptions: any[]
  roleOptions: any[]
  visible: boolean
  showLoading: boolean
  configModalVisible: boolean
  invalidChecks: any[]
  forceReset: boolean
  updateExplain: string
  favoriteTemplateName: string
  favoriteUpdateExplain: string
  filterGroup: string
  previewVisible: boolean
  previewLoading: boolean
  testData: any
  checkPanelVisible: boolean
  templateName: string
  importableHead: boolean
  importableDistrict: boolean
  targetStaff: string
  targetEntityName: string
  draftCreatedTime: any
  currentFavoritesTemplate: any
  acitveGroupId: any
  importableTemplates: any
  currentLessonId: number
}

@inject('globalStore', 'levelStore')
@observer
class LevelConfig extends ComponentExt<ILevelConfigProps, ILevelConfigState> {
  state = {
    lesson_id: 0,
    role_id: '',
    defaultLessonId: 0,
    lessonOptions: [],
    roleOptions: [],
    visible: false,
    showLoading: false,
    configModalVisible: false,
    invalidChecks: [],
    forceReset: false,
    updateExplain: '',
    filterGroup: '',
    previewVisible: false,
    previewLoading: false,
    testData: null,
    checkPanelVisible: false,
    favoriteVisible: false,
    templateName: '',
    importableHead: false,
    importableDistrict: false,
    targetStaff: '',
    targetEntityName: '',
    draftCreatedTime: null,
    favoriteTemplateName: '',
    favoriteUpdateExplain: '',
    currentFavoritesTemplate: null,
    importableTemplates: [],
    acitveGroupId: '',
    currentLessonId: 0,
  }

  checkGroupBoardRef

  onCheckRolesScroll = throttle(async (evt): Promise<any> => {
    const isBottom =
      evt && evt.target
        ? evt.target.scrollHeight -
            (evt.target.scrollTop + evt.target.clientHeight) <=
          10
        : false
    const {
      levelStore: {
        checkRolesMeta: {
          pagination: { current_page, total },
        },
        checkRoles,
        getEntityList,
      },
    } = this.props
    if (isBottom && total > checkRoles.length) {
      getEntityList(
        levelStrategies.CHECK_ROLES,
        {
          lesson_id: this.state.lesson_id,
          page: current_page + 1,
        },
        'append',
      )
    }
  }, 300)

  onFavoritesChange = debounce(async value => {
    const {
      levelStore: { getEntityList },
    } = this.props
    getEntityList(levelStrategies.FAVORITES_TEMPLATE, {
      name: value,
      with_detail: true,
    })
  }, 600)

  onFavoritesMenuScroll = throttle(async evt => {
    const isBottom =
      evt && evt.target
        ? evt.target.scrollHeight -
            (evt.target.scrollTop + evt.target.clientHeight) <=
          10
        : false

    const {
      levelStore: {
        favoritesTemplateMeta: {
          pagination: { current_page, total },
        },
        favoritesTemplate,
        getEntityList,
      },
    } = this.props

    if (isBottom && total > favoritesTemplate.length) {
      getEntityList(
        levelStrategies.FAVORITES_TEMPLATE,
        {
          page: current_page + 1,
          with_detail: true,
        },
        'append',
      )
    }
  }, 600)

  private timer: any = 0

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      levelStore: {
        checkTemplate: { target_staff, target_entity_name },
      },
    } = nextProps

    return {
      targetStaff: target_staff ? target_staff : prevState.targetStaff,
      targetEntityName: target_entity_name
        ? target_entity_name
        : prevState.targetEntityName,
    }
  }

  async componentDidMount() {
    // 获取配置场景数据
    await this.getLessons({ used_for_check_config: true })
    this.init()
  }

  // 获取配置场景数据，初始化普通模板列表，根据标准模板是否存在设置导入关卡按钮的状态
  init = async (): Promise<any> => {
    const {
      levelStore: { setCheckTemplate, setCurrentCheck },
    } = this.props
    const dataFlow = this.getDataFlow()

    // 获取关卡角色数据
    const res = await dataFlow.shift()()
    this.setState({
      role_id: res.data.find(role => role.category === '默认').id,
    })
    // 获取导入模板数据
    await dataFlow.shift()()

    // 判断服务端是否存在草稿，如果存在则从服务端导入草稿
    this.getCheckTemplate({
      type: templateType.unit,
      status: '草稿',
      check_per_page: PER_PAGE,
      check_page: 1,
    }).catch(async err => {
      if (err.response.status === 404) {
        if (localStorage.getItem('template_draft')) {
          const checkTemplate = JSON.parse(
            localStorage.getItem('template_draft'),
          )

          if (checkTemplate) {
            setCheckTemplate(checkTemplate)
            setCurrentCheck(checkTemplate.checks.data[0], 0)
            this.$notify('success')({
              message: '导入草稿成功',
              duration: 2,
            })
          }
          this.setState({
            draftCreatedTime: localStorage.getItem(
              'template_draft_created_time',
            ),
          })
        } else {
          // 获取模板详情数据
          await dataFlow.shift()()
        }
      }
    })

    // 获取收藏列表数据
    await this.getFavoritesTemplate({}, 'add')
    // 开启保存模板为草稿的定时器
    this.saveDraftInterval(SAVE_DRAFT_INTERVAL)
  }

  switchLesson = async (val: number): Promise<any> => {
    const {
      levelStore: { setCurrentCheck },
    } = this.props
    setCurrentCheck(null)
    this.setState({ lesson_id: val }, async () => {
      const dataFlow = this.getDataFlow()
      const res = await dataFlow.shift()() // 获取关卡角色数据
      this.setState({
        role_id: res.data.find(role => role.category === '默认').id,
      })
      await dataFlow.shift()() // 获取导入模板数据
      await dataFlow.shift()() // 获取模板详情数据
      await dataFlow.shift()() // 获取收藏关卡数据
    })
  }

  onCheckRolesChange = (mode, val) => {
    if (mode === 'switch') {
      // 用在发布模板时，仅用于切换角色类型
      this.setState(
        {
          role_id: val,
        },
        () => {
          if (saveConfirm) {
            saveConfirm.update({
              content: this.renderConfirmOperation(),
            })
          }
        },
      )
    } else {
      confirm({
        title: '更改角色操作',
        content: (
          <p>
            更改角色操作将导致当前编辑关卡内容消失，点击<strong>确定</strong>
            将把当前关卡内容保存为草稿后并导入，点击<strong>取消</strong>
            则直接导入当前角色下的关卡
          </p>
        ),
        onOk: () => {
          this.setState(
            {
              role_id: val,
            },
            async () => {
              const {
                levelStore: { setCheckTemplate, setCurrentCheck },
              } = this.props
              this.saveDraft()
              const dataFlow = this.getDataFlow()
              await dataFlow.shift()()
              await dataFlow.shift()()
              await dataFlow.shift()
              const checkTemplate = JSON.parse(
                localStorage.getItem('template_draft'),
              )
              if (checkTemplate) {
                setCheckTemplate(checkTemplate)
                setCurrentCheck(checkTemplate.checks.data[0], 0)
              }
              await dataFlow.shift()()
            },
          )
        },
        onCancel: () => {
          this.setState(
            {
              role_id: val,
            },
            async () => {
              const dataFlow = this.getDataFlow()
              await dataFlow.shift()()
              await dataFlow.shift()()
              await dataFlow.shift()()
              await dataFlow.shift()()
            },
          )
        },
      })
    }
  }

  getDataFlow = () => {
    const flow = [
      // 获取关卡角色数据
      this.getCheckRoles.bind(this, {
        lesson_id: this.state.lesson_id,
        used_for_check_template: true,
      }),
      // 获取导入模板数据
      this.getImportableTemplates.bind(this, this.state.lesson_id),
      // 获取模板详情数据
      this.getCheckTemplate.bind(this, {
        type: templateType.unit,
        check_per_page: PER_PAGE,
        check_page: 1,
      }),
      // 获取收藏关卡数据
      this.getFavoritesTemplate.bind(this, {}, 'add'),
    ]

    return flow
  }

  getLessons = async (param?: any): Promise<any> => {
    const res = await this.api.level.getLessons(param)
    this.setState({
      lessonOptions: res,
      defaultLessonId: res[0].id,
      lesson_id: res[0].id,
    })
  }

  getImportableTemplates = async (lessonId): Promise<any> => {
    const res = await this.api.level.getImportableTemplates({
      lesson_id: this.state.lesson_id,
      role_id: this.state.role_id,
    })

    this.setState({
      importableHead: res.some(
        item => item.type === templateType.head && item.can_imported,
      ),
      importableDistrict: res.some(
        item => item.type === templateType.district && item.can_imported,
      ),
      importableTemplates: res,
    })
  }

  getCheckRoles = async (param: any): Promise<any> =>
    await this.props.levelStore.getEntityList(
      levelStrategies.CHECK_ROLES,
      param,
    )

  getCheckTemplate = async (param: any, mode = 'add') => {
    const { lesson_id, role_id } = this.state
    const {
      levelStore: {
        getEntityList,
        currentCheck,
        setCurrentCheck,
        currentCheckIndex,
        setTasks,
      },
    } = this.props
    if (!lesson_id) {
      this.$message.info('请先选择配置场景。')
      return Promise.resolve()
    }

    if (!role_id) {
      this.$message.info('请先选择配置关卡角色')
      return Promise.resolve()
    }

    return getEntityList(
      levelStrategies.CHECK_TEMPLATE,
      {
        lesson_id,
        role_id,
        ...param,
      },
      mode,
    )
      .then(async () => {
        if (!currentCheck) {
          const {
            levelStore: {
              checkTemplate: {
                checks: { data },
              },
            },
          } = this.props
          const singleCheckData = await getEntityList(
            levelStrategies.SINGLE_CHECK,
            {
              id: data[0].id,
            },
          )
          setTasks(singleCheckData, 0)
          setCurrentCheck(singleCheckData, 0)
        } else {
          setCurrentCheck(currentCheck, currentCheckIndex)
        }
        this.getTemplUpdateInfo({ lesson_id, type: templateType.head })
      })
      .catch(err => {
        setCurrentCheck(null)
      })
  }

  getTemplUpdateInfo = async (param: any): Promise<any> => {
    const {
      levelStore: { getTemplUpdateInfo },
    } = this.props
    getTemplUpdateInfo(param).catch(err => {})
  }

  getFavoritesTemplate = async (param: any, mode) => {
    const {
      levelStore: { getEntityList },
    } = this.props
    return getEntityList(
      levelStrategies.FAVORITES_TEMPLATE,
      { ...param, with_detail: true, lesson_id: this.state.lesson_id },
      mode,
    )
  }

  inputUpdateExplain = e => {
    this.setState(
      {
        updateExplain: e.target.value,
      },
      () => {
        saveConfirm.update({
          content: this.renderConfirmOperation(),
        })
      },
    )
  }

  inputTemplateName = e => {
    this.setState(
      {
        templateName: e.target.value,
      },
      () => {
        saveConfirm.update({
          content: this.renderConfirmOperation(),
        })
      },
    )
  }

  inputFavoriteTemplateName = e => {
    this.setState({ favoriteTemplateName: e.target.value }, () => {
      favoritesForm.update({
        content: this.renderFavoritesForm(this.state.currentFavoritesTemplate),
      })
    })
  }

  inputFavoriteUpdateExplain = e => {
    this.setState({ favoriteUpdateExplain: e.target.value }, () => {
      favoritesForm.update({
        content: this.renderFavoritesForm(this.state.currentFavoritesTemplate),
      })
    })
  }

  canPublishCheckTemplateType = (type: string): boolean => {
    const {
      globalStore: {
        staffInfo: { can_publish_check_template_types },
      },
    } = this.props

    return (
      can_publish_check_template_types &&
      can_publish_check_template_types.some(t => type === t)
    )
  }

  switchForceReset = val => {
    this.setState({ forceReset: val })
  }

  showSaveTemplateConfirm = type => {
    const {
      levelStore: { currentCheck, currentCheckIndex, setCurrentCheck },
    } = this.props
    const { lesson_id, lessonOptions } = this.state

    const payload = this.getConfigPayload({ type })

    if (this.invalidField(payload)) {
      return
    }

    saveConfirm = confirm({
      title: (
        <div>
          <span style={{ fontSize: 24, color: '#FB4634' }}>
            {lessonOptions.find(lession => lession.id === lesson_id).name}{' '}
          </span>
          模板发布提醒
        </div>
      ),
      okType: 'danger',
      content: this.renderConfirmOperation(),
      onOk: () => {
        if (!this.state.updateExplain || !this.state.templateName) {
          this.$notify('info')({
            message: '请输入关卡名称或关卡说明',
            duration: 2,
          })
          return Promise.reject()
        }
        this.onTemplSubmit(type)
        this.switchForceReset(false)
        setCurrentCheck(currentCheck, currentCheckIndex)
        this.setState({ updateExplain: '', templateName: '' })
      },
      onCancel: () => {
        this.switchForceReset(false)
        this.setState({ updateExplain: '', templateName: '' })
      },
    })
  }

  renderConfirmOperation = () => {
    return (
      <div key={this.state.role_id}>
        <Row type="flex" align="middle">
          <Col span={6}>通关名称：</Col>
          <Col span={18}>
            <Input
              value={this.state.templateName}
              placeholder={'请为关卡起一个标题'}
              onChange={this.inputTemplateName}
            />
          </Col>
        </Row>
        <Row type="flex" align="middle" style={{ marginTop: 10 }}>
          <Col span={6}>适用角色：</Col>
          <Col span={18}>{this.renderCheckRolesSelect('switch')}</Col>
        </Row>
        <Row>
          <Col span={6} style={{ marginTop: 10 }}>
            关卡说明：
          </Col>
          <Col span={18} style={{ marginTop: 10 }}>
            <div>
              <TextArea
                value={this.state.updateExplain}
                placeholder={'请输入关卡说明'}
                rows={4}
                onChange={this.inputUpdateExplain}
              />
            </div>
          </Col>
        </Row>

        <div style={{ marginTop: 10 }}>
          <p>本次发布是否影响正在进阶员工？</p>
          <p>
            如是，员工将重新开始通关
            <span style={{ color: 'red' }}>（慎重选择）</span>
          </p>
          <p>如否，则只有未做的关卡会更新为最新</p>
          <Switch
            checkedChildren="是"
            unCheckedChildren="否"
            onChange={this.switchForceReset}
          />
        </div>
      </div>
    )
  }

  openConfigInstruction = (): void => {
    this.setState({
      visible: true,
    })
  }

  closeConfigInstruction = (): void => {
    this.setState({
      visible: false,
    })
  }

  showConfirm = (type: string): void => {
    confirm({
      title: '确认重新导入进阶课程标准模板',
      content:
        ' 导入模板后，将会覆盖当前正在编辑的关卡，如需保留可进行收藏操作（按钮在页面最底部）',
      onOk: () => {
        this.importLessionTemplate(type)
      },
      onCancel() {},
    })
  }

  importLessionTemplate = (type): void => {
    const { lesson_id } = this.state
    const {
      levelStore: { setCurrentCheck },
    } = this.props
    if (!lesson_id) {
      this.$message.info('请先选择配置场景。')
      return
    }

    setCurrentCheck(null)
    this.getCheckTemplate({
      lesson_id,
      type,
      check_per_page: PER_PAGE,
      check_page: 1,
    })
  }

  // order = -1 默认从卡片列表最后插入
  addCheck = (type: string, order = -1): void => {
    const {
      levelStore: { addCheck },
    } = this.props
    let check: any = {
      id: Date.now(),
      title: '',
      type,
      tasks: [],
    }

    if (type === checkType.integration) {
      check = {
        ...check,
        pass_days: 0,
        configs: {
          video_time_length: 0,
          video_count: 0,
        },
      }
    } else {
      check = {
        ...check,
        pass_days: 0,
        configs: {},
      }
    }

    addCheck(check, order)
    this.setCurrentCheck(check, order)
  }

  compareTemplate = (orgTemp, newTemp) => {
    // 比较两个对象是否一致,如果一致则说明模板没有被修改过
    const orgTempJs = toJS(orgTemp)
    const newTempJs = toJS(newTemp)
    const orgTempKeys = Object.keys(orgTempJs)
    const newTempKeys = Object.keys(newTempJs)

    /* if (orgTempKeys.length !== newTempKeys.length) {
      return false
    }*/
    // let result = false
    for (let i = 0; i < newTempKeys.length; i++) {
      if (
        newTempJs[newTempKeys[i]] !== null &&
        newTempJs[newTempKeys[i]] !== undefined &&
        typeof newTempJs[newTempKeys[i]] === 'object'
      ) {
        // 如果是数组或者对象,递归比较

        if (newTempJs[newTempKeys[i]] instanceof Array) {
          // 如果是数组,则遍历数组比较

          if (
            orgTempJs[orgTempKeys[i]].length ===
            newTempJs[newTempKeys[i]].length
          ) {
            // 如果数组长度不一致,则说明被修改

            for (let j = 0; j < newTempJs[newTempKeys[i]].length; j++) {
              // 递归遍历比较
              const res = this.compareTemplate(
                orgTempJs[newTempKeys[i]][j],
                newTempJs[newTempKeys[i]][j],
              )
              if (!res) {
                return false
              }
            }
          } else {
            return false
          }
        } else {
          // 不是数组,是对象
          const res = this.compareTemplate(
            orgTempJs[newTempKeys[i]],
            newTempJs[newTempKeys[i]],
          )
          if (!res) {
            return false
          }
        }
      } else {
        if (orgTempJs[newTempKeys[i]] === newTempJs[newTempKeys[i]]) {
          // 如果键名顺序不对则
          // return false
        } else {
          return false
        }
      }
    }
    return true
  }

  getConfigPayload = (param?) => {
    const {
      lesson_id,
      forceReset,
      role_id,
      updateExplain,
      templateName,
    } = this.state
    const {
      levelStore: { checkTemplate },
    } = this.props

    const checks = toJS(checkTemplate.checks.data)

    checks.map((item, index) => {
      if ((item.id + '').indexOf('new') > -1) {
        // 如果id中包含new字符串,则说明该关卡是新建的,要删除掉id
        delete item.id
      }
    })
    const payload: any = {
      id: checkTemplate.id,
      lesson_id,
      role_id,
      checks,
      check_groups: toJS(checkTemplate.check_groups),
      force_reset: forceReset,
      name: templateName || `模板：${Date.now()}`,
      update_explain: updateExplain || `模板：${Date.now()}`,
      snapshot_id: checkTemplate.snapshot_id,
    }

    if (
      (payload.check_groups && payload.check_groups.length === 0) ||
      !payload.check_groups
    ) {
      delete payload.check_groups
    }

    return {
      ...payload,
      ...param,
    }
  }

  onTemplSubmit = async (type: string): Promise<any> => {
    const { lesson_id } = this.state
    const {
      levelStore: { publishCheckTemplate },
    } = this.props

    const payload = this.getConfigPayload({ type })

    publishCheckTemplate(payload)
      .then(res => {
        this.$notify('success')({
          message: `${type}发布成功`,
          duration: 2,
        })
        /*this.getCheckTemplate({
          lesson_id,
          type,
          check_per_page: PER_PAGE,
          check_page: 1
        })*/
      })
      .catch(err => {
        const {
          response: {
            data: { message },
          },
        } = err
        this.$notify('error')({
          message: message,
          duration: 2,
        })
      })
  }

  addInvalidCheckId = invalidChecks => {
    this.setState({ invalidChecks })
  }

  invalidField = (payload, opt = { showMsg: true }): boolean => {
    const checks = payload.checks
    const validator = new Validator()
    const entriesChecks: any[] = Object.entries(checks)
    const invalidChecks = []
    const emptyGroups = []
    const errMsgMap = {
      name: num => `第 ${num} 关的关卡名称不能为空`,
      'maxLength:4': num => `第 ${num} 关的关卡名称不得超过 4 个字`,
      description: num => `第 ${num} 关的关卡描述不能为空`,
      example: num => `第 ${num} 关的试题内容不能为空`,
      exam: num => `第 ${num} 关的习题内容不能为空`,
      text: num => `第 ${num} 关的文字内容不能为空`,
    }

    for (const [index, check] of entriesChecks) {
      const tasks = _get(check, 'tasks')
      if (tasks) {
        // 如果tasks不存在,说明该关卡没有编辑过,不进行校验
        const target = Number(index) + 1
        validator.add(check.name ? check.name.trim() : '', [
          {
            strategy: 'isNonEmpty',
            errMsg: errMsgMap.name(target),
            cb: () =>
              invalidChecks.push({ index, errMsg: errMsgMap.name(target) }),
          },
        ])

        validator.add(check.description ? check.description.trim() : '', [
          {
            strategy: 'isNonEmpty',
            errMsg: errMsgMap.description(target),
            cb: () =>
              invalidChecks.push({
                index,
                errMsg: errMsgMap.description(target),
              }),
          },
        ])

        if (check.type === checkType.example) {
          const exampleTitTes = _get(check, 'tasks[0].example_titles')
          validator.add(
            tasks.length < 1 || (exampleTitTes && exampleTitTes.length < 1),
            [
              {
                strategy: 'custom',
                errMsg: errMsgMap.example(target),
                cb: () =>
                  invalidChecks.push({
                    index,
                    errMsg: errMsgMap.example(target),
                  }),
              },
            ],
          )
        }

        if (check.type === checkType.exam) {
          const examTitTes = _get(check, 'tasks[0].exam_titles')
          validator.add(
            tasks.length < 1 || (examTitTes && examTitTes.length < 1),
            [
              {
                strategy: 'custom',
                errMsg: errMsgMap.exam(target),
                cb: () =>
                  invalidChecks.push({ index, errMsg: errMsgMap.exam(target) }),
              },
            ],
          )
        }

        if (check.type === checkType.text) {
          validator.add(check.tasks.length > 0 && !check.tasks[0].text.text, [
            {
              strategy: 'custom',
              errMsg: errMsgMap.text(target),
              cb: () =>
                invalidChecks.push({ index, errMsg: errMsgMap.text(target) }),
            },
          ])
        }
      }
    }

    // 如果有关卡存在分组情况
    if (checks.some(check => !!check.group_id)) {
      checks.forEach((check, index) => {
        if (!check.group_id) {
          emptyGroups.push(index + 1)
        }
      })
    }

    if (emptyGroups.length > 0) {
      if (opt.showMsg) {
        this.$notify('warning')({
          message: `第 ${emptyGroups.join('、')} 关卡无分组，请设置后发布。`,
          duration: 2,
        })
      }
      return true
    }

    const errors = validator.start(true)
    this.addInvalidCheckId(invalidChecks)
    if (errors.length > 0) {
      this.addInvalidCheckId(invalidChecks)
      if (opt.showMsg) {
        this.$notify('warning')({
          message: '部分关卡未完善，请完善后发布',
          duration: 2,
        })
      }
      return true
    }
    return false
  }

  toggleCongfigContentModal = (contentType: string): void => {
    this.setState({
      configModalVisible: !this.state.configModalVisible,
    })

    const {
      levelStore: { toggleConfigContentVisible },
    } = this.props

    toggleConfigContentVisible(contentType)
  }

  setCurrentCheck = async (check: any, index: number) => {
    const {
      levelStore: { setCurrentCheck, getEntityList, setTasks },
    } = this.props

    if (check.id && check.id !== '') {
      // 如果id 为空则不请求
      if (check.tasks) {
        // 如果已经请求过了就不请求了
        setCurrentCheck(check, index)
        return
      }
      const singleCheckData = await getEntityList(
        levelStrategies.SINGLE_CHECK,
        {
          id: check.id,
        },
      )
      setTasks(singleCheckData, index)
      setCurrentCheck(singleCheckData, index)
    } else {
      setCurrentCheck(check, index) // 如果id不存在,则说明该关卡是新增的
    }
  }

  filterCheckTemplate = group => {
    this.setState({
      filterGroup: group,
    })
  }

  setLessonId = id => {
    this.setState({
      currentLessonId: id,
    })
  }

  togglePreviewModal = async (
    visible: boolean,
    type: string,
    id?: string | number | boolean,
    isOwn = true,
  ): Promise<any> => {
    const {
      levelStore: {
        getPreviewUserCheckRecord,
        orgCheckTemplate,
        checkTemplate,
      },
    } = this.props
    if (!visible) {
      this.setState({ previewVisible: visible })
    } else {
      try {
        const compareRes = this.compareTemplate(orgCheckTemplate, checkTemplate)
        message.loading('生成模板预览中...', 0)
        if (compareRes) {
          if (typeof id === 'boolean' && isOwn) {
            const template = await this.api.level.getCheckTemplate(
              {
                lesson_id: this.state.lesson_id,
                role_id: this.state.role_id,
                type,
                check_per_page: PER_PAGE,
                per_page: PER_PAGE,
                check_page: 1,
              },
              { showMsg: false },
            )
            this.setLessonId(template.id)
            await getPreviewUserCheckRecord(
              { id: template.id, per_page: PER_PAGE },
              { showMsg: false },
            )
          } else {
            let newId = id
            if (!isOwn) {
              // 如果不是自己的模板
              newId = this.state.importableTemplates[id as string]
                ? this.state.importableTemplates[id as string].id
                : undefined // 这里的id，可能是预览导入的模板，使用的index
            }
            this.setLessonId(newId) // 保存当前课程的id
            await getPreviewUserCheckRecord(
              { id: newId, per_page: PER_PAGE },
              { showMsg: false },
            )
          }

          message.destroy()
        } else {
          if (!isOwn) {
            const newId = this.state.importableTemplates[id as string]
              ? this.state.importableTemplates[id as string].id
              : undefined // 这里的id，可能是预览导入的模板，使用的index
            this.setLessonId(newId) // 保存当前的课程id
            await getPreviewUserCheckRecord(
              { id: newId, per_page: PER_PAGE },
              { showMsg: false },
            )
          } else {
            const payload = this.getConfigPayload({
              type: templateType.unit,
              per_page: PER_PAGE,
            })

            this.setLessonId(payload.id) // 保存当前的课程id
            await getPreviewUserCheckRecord(payload, { showMsg: false })
          }

          message.destroy()
        }
      } catch (err) {
        message.destroy()
        if (err.response.status === 404 || err.response.status === 422) {
          this.$notify('warning')({
            message: '预览模板不存在',
            duration: 2,
          })
        } else {
          this.$notify('info')({
            message: err.response.data.message,
            duration: 2,
          })
        }
        return false
      }

      this.setState({
        previewVisible: true,
      })
    }
  }

  fetchTestData = async id => {
    const testData = await this.api.level.getCheckTaskRecordDetail(id)
    this.setState({
      testData,
    })
  }

  openCheckPanelModal = async (check: any): Promise<any> => {
    const {
      levelStore: { setCurrentUserCheck, getPreviewStudyCheckRecords },
    } = this.props

    const checkData = await getPreviewStudyCheckRecords(check.id)

    if (!check.is_locked) {
      if (
        check.check.type === checkType.exam ||
        check.check.type === checkType.example
      ) {
        const checkTask = _get(checkData, 'check_task_records[0]')
        await this.fetchTestData(checkTask.id)
      }

      this.setState({
        checkPanelVisible: true,
      })
      setCurrentUserCheck(checkData)
      return
    }
  }

  onCloseCheckPanelModal = () => {
    const {
      levelStore: { setCurrentUserCheck },
    } = this.props
    this.setState({ checkPanelVisible: false })
    setCurrentUserCheck(null)
  }

  toggleCheckSettings = () => {
    const {
      levelStore: { toggleCheckSettingsModal },
    } = this.props
    toggleCheckSettingsModal()
  }

  renderUserInfoCom = (): React.ReactElement<any> => {
    const {
      globalStore: { staffInfo },
      levelStore: {
        checkTemplate: { target_entity_name, target_staff },
      },
    } = this.props
    const { targetStaff, targetEntityName } = this.state
    const { entity, staff_name, staff_level } = staffInfo

    return (
      <Fragment>
        <div className={styles.levelConfigUserInfoHeader}>
          <h2>通关内容配置</h2>
          <Button onClick={this.openConfigInstruction}>配置操作说明</Button>
          <Button onClick={this.toggleCheckSettings}>通关角色设置</Button>
        </div>
        <ul>
          <li>单位：{entity && entity.entity_name}</li>
          <li>姓名：{staff_name}</li>
          <li>身份：{staff_level}</li>
          <li>
            关卡覆盖员工：
            {`${target_entity_name || targetEntityName} ${target_staff ||
              targetStaff}`}
          </li>
        </ul>
      </Fragment>
    )
  }

  toggleFavoritesModal = () => {
    const {
      levelStore: { toggleFavoritesModal, favoritesVisible },
    } = this.props
    if (!favoritesVisible) {
      this.getFavoritesTemplate(
        {
          lesson_id: this.state.lesson_id,
        },
        'add',
      )
    }
    toggleFavoritesModal()
  }

  renderCheckRolesSelect = (mode?) => {
    const { role_id } = this.state
    const {
      levelStore: { checkRoles },
    } = this.props

    return (
      <Select
        defaultValue={role_id}
        value={role_id}
        style={{ minWidth: 235 }}
        onSelect={this.onCheckRolesChange.bind(this, mode)}
        onPopupScroll={this.onCheckRolesScroll}
        placeholder={'请选择配置关卡角色'}
      >
        {checkRoles.map(role => (
          <Option key={role.id} value={role.id}>
            {role.name && role.name.length > 10
              ? withPopover({
                  content: role.name,
                  overlayStyle: { zIndex: 10000 },
                  placement: 'bottom',
                })(<span>{role.name}</span>)
              : role.name}
          </Option>
        ))}
      </Select>
    )
  }

  renderConfigHandlerCom = () => {
    const { lessonOptions, importableHead, importableDistrict } = this.state
    const {
      levelStore: {
        checkTemplate: {
          type,
          updated_at,
          update_explain,
          checks: { data },
        },
      },
    } = this.props

    return (
      <Fragment>
        <div className={styles.levelConfigSelectLandscape}>
          <div className={styles.levelConfigScenarioItem}>
            <h3>进阶等级选择：</h3>
            <Select
              defaultValue={4}
              style={{
                minWidth: 200,
              }}
              onChange={this.switchLesson}
              placeholder={'请选择课程类型'}
            >
              {lessonOptions &&
                lessonOptions.map(config => (
                  <Option key={config.id} value={config.id}>
                    {config.name}
                  </Option>
                ))}
            </Select>
          </div>
          <div className={styles.levelConfigScenarioItem}>
            <h3>通关角色选择：</h3>
            {this.renderCheckRolesSelect()}
          </div>
        </div>
        <div className={styles.levelConfigScenarioItem}>
          <h3>通关模板导入：</h3>
          <Row type="flex" align="top">
            <Col span={8}>
              <div>
                <Button
                  disabled={!importableHead}
                  style={
                    importableHead
                      ? {
                          color: '#FB4634',
                          border: '1px solid #FB4634',
                        }
                      : {}
                  }
                  className={styles.scenarioImportBtn}
                  onClick={this.showConfirm.bind(this, templateType.head)}
                >
                  总部模板
                </Button>
                <Button
                  className={styles.previewIcon}
                  onClick={this.togglePreviewModal.bind(
                    this,
                    true,
                    templateType.head,
                    0,
                    false, // 是否是自己编辑的模板
                  )}
                  disabled={!importableHead}
                >
                  预览模板
                </Button>
              </div>
              {type === templateType.head && (
                <div className={styles.scenarioDesc}>
                  <p>
                    最近更新：<span>{updated_at}</span>
                  </p>
                  <p>
                    影响角色：<span>{'业务员'}</span>
                  </p>
                  <p>
                    更新说明：<span>{update_explain}</span>
                  </p>
                </div>
              )}
            </Col>
            <Col span={8}>
              <div>
                <Button
                  disabled={!importableDistrict}
                  style={
                    importableDistrict
                      ? {
                          color: '#FB4634',
                          border: '1px solid #FB4634',
                        }
                      : {}
                  }
                  className={styles.scenarioImportBtn}
                  onClick={this.showConfirm.bind(this, templateType.district)}
                >
                  片区模板
                </Button>
                <Button
                  className={styles.previewIcon}
                  onClick={this.togglePreviewModal.bind(
                    this,
                    true,
                    templateType.district,
                    1,
                    false, // 是否是自己编辑的模板
                  )}
                  disabled={!importableDistrict}
                >
                  预览模板
                </Button>
              </div>
              {type === templateType.district && (
                <div className={styles.scenarioDesc}>
                  <p>
                    最近更新：<span>{updated_at}</span>
                  </p>
                  <p>
                    影响角色：<span>{'业务员'}</span>
                  </p>
                  <p>
                    更新说明：<span>{update_explain}</span>
                  </p>
                </div>
              )}
            </Col>
            <Col span={8}>
              <Button onClick={this.toggleFavoritesModal}>单位模板管理</Button>
            </Col>
          </Row>
        </div>
        <div className={styles.levelConfigLandscape}>
          <div className={styles.levelConfigScenarioItem}>
            <h3>添加关卡：</h3>
            <Button
              onClick={this.addCheck.bind(
                this,
                checkType.integration,
                data.length,
              )}
            >
              <Icon type="plus" />
              {checkType.integration}
            </Button>
            <Button
              onClick={this.addCheck.bind(this, checkType.example, data.length)}
            >
              <Icon type="plus" />
              {checkType.example}
            </Button>
            <Button
              onClick={this.addCheck.bind(this, checkType.exam, data.length)}
            >
              <Icon type="plus" />
              {checkType.exam}
            </Button>
            <Button
              onClick={this.addCheck.bind(this, checkType.text, data.length)}
            >
              <Icon type="plus" />
              {checkType.text}
            </Button>
          </div>
          <div className={styles.levelConfigScenarioItem}>
            <h3>添加内容：</h3>
            <Button
              onClick={this.toggleCongfigContentModal.bind(
                this,
                taskType.example,
              )}
            >
              <Icon type="plus" />
              个性题目
            </Button>
            <Button
              onClick={this.toggleCongfigContentModal.bind(
                this,
                taskType.video,
              )}
            >
              <Icon type="plus" />
              专属视频
            </Button>
          </div>
        </div>
      </Fragment>
    )
  }

  saveDraftInterval = interval => {
    return (this.timer = setInterval(() => {
      const payload = this.getConfigPayload({ type: templateType.unit })

      // 校验参数，如果不符合规则则重启 10s 定时器
      if (this.invalidField(payload, { showMsg: false })) {
        clearInterval(this.timer)
        this.timer = this.saveDraftInterval(10000)
        return
      }

      // 参数校验通过，保存草稿
      this.saveDraft()

      // 如果先前是 10s 定时器，则重置为 5min 定时器
      if (interval === 10000) {
        clearInterval(this.timer)
        this.timer = this.saveDraftInterval(SAVE_DRAFT_INTERVAL)
      }
    }, interval))
  }

  saveDraft = async () => {
    const {
      levelStore: { checkTemplate, addEntity },
    } = this.props
    const payload = this.getConfigPayload({ type: templateType.unit })

    // @todo 如果内容没有发生改变则直接返回

    const now = Date.now()
    const text = `草稿 ${now}`

    payload.name = text
    payload.update_explain = text
    localStorage.setItem('template_draft', JSON.stringify(checkTemplate))
    localStorage.setItem('template_draft_created_time', now.toString())

    this.setState({
      draftCreatedTime: now.toString(),
    })

    await addEntity(levelStrategies.TEMPLATE_DRAFT, payload)
    this.$notify('success')({
      message: `草稿保存于${moment(now).format('YYYY/MM/DD hh:mm:ss')}`,
      duration: 2,
    })
  }

  renderFavoritesForm = template => {
    return (
      <div>
        <Row type="flex" align="middle">
          <Col span={6}>通关名称：</Col>
          <Col span={18}>
            <Input
              value={
                this.state.favoriteTemplateName || (template && template.name)
              }
              placeholder={'请为关卡起一个标题'}
              onChange={this.inputFavoriteTemplateName}
            />
          </Col>
        </Row>
        <Row>
          <Col span={6} style={{ marginTop: 10 }}>
            关卡说明：
          </Col>
          <Col span={18} style={{ marginTop: 10 }}>
            <div>
              <TextArea
                value={
                  this.state.favoriteUpdateExplain ||
                  (template && template.update_explain)
                }
                placeholder={'请输入关卡说明'}
                rows={4}
                onChange={this.inputFavoriteUpdateExplain}
              />
            </div>
          </Col>
        </Row>
      </div>
    )
  }

  handleFavoriteTemplate = (template?) => {
    const isEdit = !!template
    const title = isEdit ? '编辑收藏' : '新建收藏'

    this.setState({
      currentFavoritesTemplate: template,
      favoriteTemplateName: isEdit ? template.name : '',
      favoriteUpdateExplain: isEdit ? template.update_explain : '',
    })
    favoritesForm = confirm({
      title,
      content: this.renderFavoritesForm(template),
      onOk: async () => {
        const { favoriteTemplateName, favoriteUpdateExplain } = this.state
        const {
          levelStore: { addEntity, checkTemplate },
          levelStore,
        } = this.props
        const payload = this.getConfigPayload({
          type: templateType.unit,
          from_template_id: checkTemplate.id,
        })

        if (!isEdit && (!favoriteTemplateName || !favoriteUpdateExplain)) {
          this.$message.error('请输入关卡名称或关卡说明。')
          return Promise.reject()
        }

        if (this.invalidField(payload)) {
          return
        }

        payload.name = favoriteTemplateName
        payload.update_explain = favoriteUpdateExplain

        levelStore.changeHook(false)
        if (isEdit) {
          payload.id = template.id
          payload.name = favoriteTemplateName || checkTemplate.name
          payload.update_explain =
            favoriteUpdateExplain || checkTemplate.update_explain
          await addEntity(levelStrategies.FAVORITES_TEMPLATE, payload)
        } else {
          await addEntity(levelStrategies.FAVORITES_TEMPLATE, payload)
        }
        levelStore.changeHook(true)

        this.$notify('success')({
          message: '模板收藏成功',
          duration: 2,
        })
        this.getFavoritesTemplate({}, 'add')
        this.setState({ favoriteTemplateName: '', favoriteUpdateExplain: '' })
      },
      onCancel: () =>
        this.setState({ favoriteTemplateName: '', favoriteUpdateExplain: '' }),
    })
  }

  renderFavoritesOperation = () => {
    return (
      <Dropdown overlay={this.renderFavoritesMenu()} trigger={['click']}>
        <a>收藏</a>
      </Dropdown>
    )
  }

  renderFavoritesMenu = () => {
    const {
      levelStore: { favoritesTemplate },
    } = this.props

    return (
      <ul
        className={styles.favoritesListWrapper}
        onScroll={evt => this.onFavoritesMenuScroll(evt)}
      >
        <li>
          <Search
            placeholder={'搜索收藏关卡'}
            onSearch={this.onFavoritesSearch}
            onChange={evt => this.onFavoritesChange(evt.target.value)}
          />
        </li>
        <li
          style={{ height: 200, overflowY: 'scroll' }}
          className={styles.favoritesList}
        >
          <p onClick={this.handleFavoriteTemplate.bind(this, null)}>
            <Icon type="plus-circle" /> <span>新建收藏</span>
          </p>
          {favoritesTemplate.map(template => {
            return (
              <p
                key={template.id}
                onClick={this.handleFavoriteTemplate.bind(this, template)}
              >
                <Icon type="plus-circle" /> <span>{template.name}</span>
              </p>
            )
          })}
        </li>
      </ul>
    )
  }

  onFavoritesSearch = value => {
    this.getFavoritesTemplate({ name: value }, 'add')
  }

  renderConfigInfoCom = () => {
    const {
      levelStore: {
        checkTemplate,
        currentCheck,
        currentCheckIndex,
        selectedGroupId,
        checkRoles,
      },
      globalStore: {
        staffInfo: { can_publish_check_template_types },
      },
    } = this.props
    const { filterGroup, draftCreatedTime } = this.state
    let {
      checks: { data },
      check_groups,
    } = checkTemplate
    const { invalidChecks, lesson_id } = this.state

    if (filterGroup) {
      data = data.filter(check => check.group_id === filterGroup)
    }
    return (
      <Fragment>
        <div className={styles.levelConfigInfoHeader}>
          <Row type="flex" align="middle">
            <Col span={12}>
              <span>已添加：{`${data.length}关`}</span>
            </Col>
            <Col span={12} style={{ textAlign: 'right' }}>
              <span style={{ fontSize: 14 }}>按分组排序：</span>
              <Select
                style={{ minWidth: 100 }}
                defaultValue={null}
                placeholder={'请选择关卡分组'}
                onChange={this.filterCheckTemplate}
              >
                <Option value={null}>全部</Option>
                {check_groups &&
                  check_groups.map(group => (
                    <Option key={group.id} value={group.id}>
                      {group.name}
                    </Option>
                  ))}
              </Select>
            </Col>
          </Row>

          <ul className={styles.configCardWrapper}>
            <PoseGroup>
              {data &&
                data.map((d, index) => {
                  const invalidCheck = invalidChecks.find(
                    check => check.index === index.toString(),
                  )
                  return (
                    <PosedItem key={index}>
                      {invalidCheck
                        ? withPopover({
                            content: (
                              <div>
                                <Icon
                                  type="info-circle"
                                  style={{ color: '#fb4634', marginRight: 5 }}
                                />
                                {invalidCheck.errMsg}
                              </div>
                            ),
                            placement: 'bottom',
                            overlayStyle: {
                              maxWidth: 300,
                            },
                          })(
                            <Button
                              className={styles.checkItemBtn}
                              style={{ color: '#fb4634' }}
                              onClick={this.setCurrentCheck.bind(
                                this,
                                d,
                                index,
                              )}
                            >
                              {`${index + 1}/${d.type}/${d.name || ''}`}
                            </Button>,
                          )
                        : withPopover({
                            content: `${index + 1}/${d.type}/${d.name || ''}`,
                          })(
                            <Button
                              className={styles.checkItemBtn}
                              style={{
                                fontWeight:
                                  selectedGroupId === d.group_id
                                    ? 'bold'
                                    : 'normal',
                              }}
                              onClick={this.setCurrentCheck.bind(
                                this,
                                d,
                                index,
                              )}
                            >
                              {`${index + 1}/${d.type}/${d.name || ''}`}
                            </Button>,
                          )}
                    </PosedItem>
                  )
                })}
            </PoseGroup>
          </ul>
          {currentCheck && (
            <ConfigCard
              key={currentCheck.id}
              currentLessonId={lesson_id}
              data={currentCheck}
              order={currentCheckIndex}
            />
          )}
        </div>
        {
          <div className={styles.levelConfigSubmit}>
            {// 只有默认类型的角色，并且满足可以发布的模板类型才可以发布总部或是片区模板
            checkRoles.some(
              role =>
                role.id === this.state.role_id && role.category === '默认',
            ) &&
              can_publish_check_template_types &&
              can_publish_check_template_types
                .filter(type => type !== templateType.unit)
                .map(type => (
                  <a
                    key={type}
                    className={styles.levelConfigHeadSubmit}
                    onClick={this.showSaveTemplateConfirm.bind(this, type)}
                  >
                    {`保存为${type}并发布`}
                  </a>
                ))}
            <a
              className={styles.previewIcon}
              onClick={this.togglePreviewModal.bind(
                this,
                true,
                templateType.unit,
                false,
              )}
            >
              预览模板
            </a>
            {this.renderFavoritesOperation()}
            <span style={{ position: 'relative' }}>
              <a className={styles.draftBtn} onClick={this.saveDraft}>
                保存为草稿
              </a>
              {draftCreatedTime && (
                <span
                  style={{
                    minWidth: 200,
                    position: 'absolute',
                    top: 22,
                    left: '50%',
                    transform: 'translateX(-50%)',
                  }}
                >
                  保存于：
                  {draftCreatedTime &&
                    moment(Number(draftCreatedTime)).format(
                      'YYYY/MM/DD hh:mm:ss',
                    )}
                </span>
              )}
            </span>
            {withPopover({
              content: `隔10分钟保存一次，或者手动点击立即保存，如保存时失败，则加大到10秒保存一次，直到成功。每次进入配置页时，默认会读取上次保存的模板。`,
              placement: 'top',
              overlayStyle: { maxWidth: 200 },
            })(
              <Icon
                type="info-circle"
                style={{ marginRight: 6, cursor: 'pointer' }}
              />,
            )}
            <Button
              className={styles.levelConfigUnitSubmit}
              disabled={
                this.canPublishCheckTemplateType(templateType.unit)
                  ? false
                  : true
              }
              type="primary"
              onClick={this.showSaveTemplateConfirm.bind(
                this,
                templateType.unit,
              )}
            >
              确认发布
            </Button>
          </div>
        }
      </Fragment>
    )
  }

  get filter(): any {
    return {
      per_page: PER_PAGE,
      page: 1,
      id: this.state.currentLessonId,
      group_id: this.state.acitveGroupId,
    }
  }

  setActiveGroup = async (index, id): Promise<any> => {
    const {
      levelStore: { getPreviewUserCheckRecord },
    } = this.props

    this.setState(
      {
        acitveGroupId: index < 0 ? '' : id,
      },
      () => {
        this.checkGroupBoardRef.setCurrentCheckGroup(0)
        if (index > -1) {
          getPreviewUserCheckRecord({
            ...this.filter,
            group_id: id,
          })
        } else {
          delete this.filter.group_id
          getPreviewUserCheckRecord(this.filter)
        }
      },
    )
  }

  onRef = ref => (this.checkGroupBoardRef = ref)

  render() {
    const {
      previewVisible,
      checkPanelVisible,
      testData,
      lessonOptions,
    } = this.state
    const {
      levelStore: { currentUserCheck },
    } = this.props

    return (
      <div className={styles.levelConfig}>
        <section className={styles.levelConfigUserInfo}>
          {this.renderUserInfoCom()}
        </section>
        <section className={styles.levelConfigScenario}>
          {this.renderConfigHandlerCom()}
        </section>
        <section className={styles.levelConfigInfo}>
          {this.renderConfigInfoCom()}
        </section>
        <AntdModal
          wrapClassName={'level-config-instruction '}
          width={680}
          visible={this.state.visible}
          title={'配置说明'}
          footer={null}
          onOk={this.openConfigInstruction}
          onCancel={this.closeConfigInstruction}
        >
          <p>
            在信息栏有单位、主管/管理员、身份等信息的展示；该信息表示了本次配置会覆盖到的单位；
          </p>
          {LEVEL_CONFIG_INFO.map(info => (
            <div key={info[0]} className={styles.line}>
              <h4>{info[0]}</h4>
              {info.slice(1, info.length).map(text => (
                <p key={text}>{text}</p>
              ))}
            </div>
          ))}
        </AntdModal>
        <ConfigContentModal />
        <CheckGroupModal />
        <CheckSettingsModal
          lessons={lessonOptions}
          checkActiveLessonID={this.state.lesson_id}
          getCheckRoles={this.getCheckRoles}
        />
        <FavoritesModal
          checkActiveLessonID={this.state.lesson_id}
          lessons={lessonOptions}
          togglePreviewModal={this.togglePreviewModal}
          exportFavoritesTemplate={this.getCheckTemplate}
        />
        <section>
          <Modal
            classNames={{
              overlay: styles.modalOverlay,
              modal: styles.plainModal,
              closeButton: styles.closeButton,
              closeIcon: styles.closeIcon,
            }}
            focusTrapped={false}
            open={previewVisible}
            onClose={this.togglePreviewModal.bind(this, false)}
          >
            <CheckGroupTab
              levelStore={this.props.levelStore}
              acitveGroupId={this.state.acitveGroupId}
              setActiveGroup={this.setActiveGroup}
            />
            <CheckGroupBoard
              openCheckPanelModal={this.openCheckPanelModal}
              onRef={this.onRef}
            />
          </Modal>
        </section>
        <Modal
          closeOnOverlayClick={false}
          showCloseIcon={false}
          focusTrapped={false}
          classNames={{
            overlay: styles.modalOverlay,
            modal: styles.customModal,
          }}
          open={checkPanelVisible}
          onClose={this.onCloseCheckPanelModal}
          center
        >
          {currentUserCheck && (
            <CheckPanel
              hiddenMusicIcon={true}
              testData={testData}
              check={currentUserCheck}
              onCloseCheckPanelModal={this.onCloseCheckPanelModal}
              onOpenPassCheckModal={null}
              onOpenFailCheckModal={null}
            />
          )}
        </Modal>
      </div>
    )
  }
}

export default RouteWrapper(routeMap.LEVEL_UP.LEVEL_CONRIG.path)(LevelConfig)
